const trackSections = document.querySelectorAll('[data-track-section]');

trackSections.forEach((section, sectionIndex) => {

  const asyncLoadingSection = section.querySelector('component-recommendations[data-products-source]');
  if (asyncLoadingSection) {
    window.waitForElement(`[data-section-id="${asyncLoadingSection.dataset.sectionId}"] component-recommendation .js-link`, asyncLoadingSection).then(() => {
      addTrackSectionListener(section, sectionIndex);
    });
  } else {
    addTrackSectionListener(section, sectionIndex);
  }
});

function addTrackSectionListener(section, sectionIndex) {
  const inner_links = section.getElementsByTagName('a');
    for (let i = 0; i < inner_links.length; i++) {
      inner_links[i].addEventListener('click', function (e) {
        let ga4FeaturedStory = section.dataset.ga4FeaturedStory ? section.dataset.ga4FeaturedStory : '';
        if (!ga4FeaturedStory && this.closest('[data-ga4-featured-story]')) {
          ga4FeaturedStory = this.closest('[data-ga4-featured-story').dataset.ga4FeaturedStory;
        }
        let moduleLink = this.getAttribute('href');
        // Send absolute urls for tracking consistency
        if (moduleLink && moduleLink.indexOf('http') === -1) {
          moduleLink = theme.ga4.shop_url + moduleLink;
        }
        window.sendGTMData && window.sendGTMData({
          event: 'home_page_module_click',
          home_module_name: section.dataset.trackSection,
          module_live_date: theme.ga4.live_date,
          home_module_item: ga4FeaturedStory,
          home_module_text: this.textContent.trim(),
          home_link_url: moduleLink,
          home_module_position: sectionIndex,
          home_module_item_position: i,
          page_title: document.title
        });
      });
    }
    const scrollEl = section.querySelector('.js-scrollable');
    if (scrollEl) {
      scrollEl.addEventListener('scroll', () => {
        const scrollPos = scrollEl.scrollLeft;
        debounce((section, scrollEl, scrollPos) => {
          const thresholds = [0.5, 1];
          const maxScrollLeft = scrollEl.scrollWidth - scrollEl.clientWidth;
          thresholds.forEach((threshold) => {
            if (scrollPos >= maxScrollLeft * threshold) {
              window.sendGTMData && window.sendGTMData({
                event: 'module_horizontal_scroll',
                home_module_name: section.dataset.trackSection,
                scroll_percentage: threshold * 100
              });
            }
          });
        }, 250);
      }, { passive: true });
    }
}